'use client';

import { signIn } from 'next-auth/react';
import { FaGoogle, FaMicrosoft } from 'react-icons/fa6';

import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';

export default function SignInPage() {
  const callbackUrl = '/matches';

  return (
    <>
      <div className="space-y-1">
        <h1 className="text-card-foreground text-xl font-semibold">
          Welcome to Zeno
        </h1>
        <p className="text-xs">
          Sign in to find your best conference connections
        </p>
      </div>

      <div className="mt-6 space-y-3">
        <Button
          variant="muted"
          onClick={() => signIn('google', { callbackUrl })}
          className="text-muted-foreground flex h-10 w-full items-center justify-center gap-3 text-base"
        >
          <FaGoogle className="size-4.5" />
          Continue with Google
        </Button>

        <Separator className="bg-input" />

        <Button
          variant="muted"
          onClick={() => signIn('microsoft', { callbackUrl })}
          className="text-muted-foreground flex h-10 w-full items-center justify-center gap-3 text-base"
        >
          <FaMicrosoft className="size-4.5" />
          Continue with Outlook
        </Button>
      </div>
    </>
  );
}
